import React, { useState, useEffect, useMemo } from 'react'
import { ArticleListPropsFromBe, IArticle } from '../../types'
import { ArticlesComponent } from './Article'
import { LoadMoreComponent } from './LoadMore'
import { PromoComponent } from './Promo'
import { loadMore, createMoreUrl, applyTag } from './helpers'
import { Tabs, TabsDisplayType } from '@vista/omnichannel-components-ui'
import { getQueryParameterByName } from '../../utils'

export const ArticleListComponent: React.FC<ArticleListPropsFromBe> = props => {
    const tabTagNodes = [
        {
            tagId: '',
            tab: {
                label: 'All',
                value: 0,
            },
        },
        ...props.tabTags.map((tag, index) => ({
            tagId: tag.id.toString(),
            tab: {
                label: tag.name.trim(),
                value: index + 1,
            },
        })),
    ]

    const tagIndexByUrlParam = () => {
        const tagQueryParam = getQueryParameterByName('tag')
        if (!tagQueryParam) return 0

        const tabIndex = tabTagNodes.findIndex(node => node.tab.label.toLowerCase() === tagQueryParam.toLowerCase())
        if (tabIndex <= 0) return 0

        return tabIndex
    }

    const [moreToLoad, setMoreToLoad] = useState(true)
    const [preloadedArticles, setPreloadedArticles] = useState<IArticle[]>(props.articleItems)
    const [displayedArticles, setDisplayedArticles] = useState<IArticle[]>(props.articleItems)
    const [pageIndex, setPageIndex] = useState<number>(1)
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(tagIndexByUrlParam())
    

    const isAuthorPage = useMemo(() => !!props.authorNodeId, [props])

    useEffect(() => {
        applyTag({
            tagId:isAuthorPage ? '' : tabTagNodes[selectedTabIndex].tagId,
            authorId: props?.authorNodeId ?? '',
            setMoreToLoad,
            setPreloadedArticles,
            setDisplayedArticles,
            loadedArticles: props.articleItems,
        })
        setPageIndex(2)
    }, [selectedTabIndex])

    const loadMoreHandler = () => {
        const url = isAuthorPage
            ? createMoreUrl(pageIndex, '', props.authorNodeId)
            : createMoreUrl(pageIndex, tabTagNodes[selectedTabIndex].tagId)
        loadMore({
            url,
            preloadedArticles,
            setMoreToLoad,
            setPreloadedArticles,
            setDisplayedArticles,
        })
        setPageIndex(pageIndex + 1)
    }

    const promoComponents: JSX.Element[] = props.promoTextLinkImgItems.map(promoProps => (
        <PromoComponent {...promoProps} />
    ))

    const onTabSelected = tab => setSelectedTabIndex(tab.value)
    const tabList = tabTagNodes.map(node => node.tab)
    const selectedTab = tabList[selectedTabIndex]

    return (
        <div className="art-list-container">
            {!isAuthorPage && (
                <div className="artist-list-container__tabs">
                    <Tabs
                        centered={true}
                        tabList={tabList}
                        onTabSelected={onTabSelected}
                        selectedTab={selectedTab}
                        displayType={TabsDisplayType.Primary}
                    />
                </div>
            )}
            <div className="art-list">
                <ArticlesComponent articles={displayedArticles} promo={promoComponents} />
                <LoadMoreComponent
                    onClick={loadMoreHandler}
                    noResultsLabel={props.displayText.noResults}
                    loadMoreLabel={props.displayText.loadMoreBtn}
                    moreToLoad={moreToLoad}
                />
            </div>
        </div>
    )
}

export default ArticleListComponent
